// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COMPLAINT_CANCEL = "Zru\u0161";
export const COMPLAINT_EXPLAIN_SIMPLE = "Napi\u0161, co nen\u00ed v po\u0159\u00e1dku a co navrhuje\u0161:";
export const COMPLAINT_SUBMIT_TO_ADMINS = "Ode\u0161li Modr\u00fd kon\u00edk teamu";
export const COMPLAINT_SUBMIT_TO_GROUP_MODS = "Ode\u0161li moder\u00e1tork\u00e1m skupiny";
export const COMPLAINT_SUBMIT_TO_MODS = "Ode\u0161li moder\u00e1tork\u00e1m t\u00e9matu";
